export const  GamesCards = [
  {
    id: 1,
    names: "Tic Tac Toe",
    image: "https://play-lh.googleusercontent.com/8MghNEelhwf-7Wn-aF21Oo15G-NiO0JXNdjgIvTkxuImJAXCSWf1OOXuUsynebdc4MU",
    link:"tictac",
  },
  {
    id: 2,
    names: "Rock paper Scissors",
    image: "https://th.bing.com/th/id/OIP.qqYdruXnPdG5RNdVq3Or4gHaFe?w=243&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
    link:"rps",
  },
  {
    id: 3,
    names: "Card Puzzle",
    image: "https://th.bing.com/th/id/R.0b691811a0377ee46942d46017a58337?rik=pECSs6PkPexh0g&riu=http%3a%2f%2fa725.phobos.apple.com%2fus%2fr30%2fPurple%2fv4%2f60%2f9d%2f4c%2f609d4cba-7138-8d28-4b1a-e954165c6933%2fmzl.idzmvbdx.png&ehk=iNXWgIaHmicWkX1BKYhcCJOM8jZ8ghTQLnwkCCW8hfQ%3d&risl=&pid=ImgRaw&r=0",
    link:"card",
  },
];



